export default {"src":"/_next/static/media/windsurfing.754d63fc.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};